import { render, staticRenderFns } from "./D2FolderList.vue?vue&type=template&id=dfe1b840"
import script from "./D2FolderList.vue?vue&type=script&lang=js"
export * from "./D2FolderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports